<template>
	<div class="login-box">
		<div v-if="postForgotPassword">
			Sofern diese E-Mail bei uns vorhanden ist, bekommst du in Kürze ein E-Mail mit einem Link, um dein Passwort
			zurücksetzen zu können.
		</div>
		<template v-else>
			<p v-if="isPostPasswordReset">
				Du hast dein Passwort erfolgreich geändert und kannst dich nun anmelden:
			</p>
			<p v-if="isAutoLogout">
				Aus Sicherheitsgründen wurdest du aufgrund zu langer Inaktivität automatisch abgemeldet.
			</p>
			<b-form @submit.prevent="login">
				<b-input v-model="email" placeholder="E-Mail Adresse" @keyup.enter="login"/>
				<div v-if="!forgotPassword" class="mt-3">
					<b-input
						v-model="password"
						type="password"
						placeholder="Passwort"
						ref="password"
						@keyup.enter="login"
					/>
				</div>
				<div class="mt-3">
					<div class="login-box--actions">
						<div>
							<Button
								v-if="forgotPassword"
								text="Link anfordern"
								:disabled="!forgotPasswordDataValid || resettingPassword"
								:loading="resettingPassword"
								icon="checkmark"
								@click="resetPassword"
							/>
							<Button
								v-else
								text="Anmelden"
								:disabled="!dataValid || loggingIn"
								:loading="loggingIn"
								icon="checkmark"
								@click="login"
							/>
						</div>
						<div v-if="forgotPassword">
							<a href="#" @click.prevent="changeForgotPassword(false)">Zum Login</a>
						</div>
						<div v-else>
							<a href="#" @click.prevent="changeForgotPassword(true)">Passwort vergessen?</a>
						</div>
					</div>
					<div v-if="error" class="error mt-3">Logindaten fehlerhaft</div>
				</div>
			</b-form>
		</template>
	</div>
</template>

<script>
import * as EmailValidator from 'email-validator';
import FormGroup from "@/vue/common/form/Group";
import Button from "@/vue/common/Button";
import {isEmptyOrNull} from "@/helper/String";
import _ from "lodash";
import Forgot from "@/api/auth/password/Forgot";
import {getQueryParams} from "@/helper/Url";
import Login from "@/api/auth/Login";
import {isDefined} from "@/helper/Value";

export default {

	components: {
		Button,
		FormGroup,
	},

	props: {
		preFillEmail: {
			type: String,
			required: false,
		},
	},

	data ()
	{
		const queryParams = getQueryParams();

		return {
			email: '',
			password: '',
			loggingIn: false,
			error: false,
			forgotPassword: isDefined(queryParams.forgotPassword),
			resettingPassword: false,
			postForgotPassword: false,
		};
	},

	computed: {
		isPostPasswordReset ()
		{
			return getQueryParams().postPasswordReset;
		},
		isAutoLogout ()
		{
			return getQueryParams().autoLogout;
		},
		emailValid ()
		{
			return !isEmptyOrNull(this.email)
				&& EmailValidator.validate(_.trim(this.email));
		},
		passwordValid ()
		{
			return !isEmptyOrNull(this.password);
		},
		forgotPasswordDataValid ()
		{
			return this.emailValid;
		},
		dataValid ()
		{
			return this.emailValid
				&& this.passwordValid;
		},
	},

	methods: {
		changeForgotPassword (value)
		{
			this.error = false;
			this.forgotPassword = value;
			this.postForgotPassword = false;
		},
		async login ()
		{
			if (!this.dataValid)
			{
				return;
			}

			this.error = false;
			this.loggingIn = true;

			try
			{
				const response = await new Login()
					.setEmail(
						_.trim(this.email)
					)
					.setPassword(this.password)
					.call();

				const queryParams = getQueryParams();

				const defaultUrl = response.data.customer
					? '/kundenbereich/jobs'
					: '/kandidat/profil/jobs';

				const postLoginUrl = queryParams.postLoginUrl
					? decodeURIComponent(queryParams.postLoginUrl)
					: undefined;

				location.href = postLoginUrl && postLoginUrl.startsWith('/')
					? postLoginUrl
					: defaultUrl;
			}
			catch (e)
			{
				this.error = true;
			}

			this.loggingIn = false;
		},
		async resetPassword ()
		{
			if (!this.forgotPasswordDataValid)
			{
				return;
			}

			this.resettingPassword = true;

			try
			{
				await new Forgot()
					.setEmail(this.email)
					.call();
			}
			catch (e)
			{

			}

			this.postForgotPassword = true;

			this.resettingPassword = false;
		}
	},

	watch: {
		preFillEmail (email)
		{
			if (email && isEmptyOrNull(this.email))
			{
				this.email = email;
			}
		}
	}
}
</script>
